module.exports = "./img/0e0b979a8ca79b350cf566bedc840ef3.jpg";